declare global {
  interface Window {
    Cookiebot?: {
      hasResponse?: boolean;
      consent?: { marketing?: boolean; statistics?: boolean };
    };
  }
}

const CONSENT_EVENTS = [
  'CookiebotOnConsentReady',
  'CookiebotOnAccept',
  'CookiebotOnDecline',
];

/**
 * Before the visitor has an answer (given, stored or implied by region)
 * Cookiebot's flags are placeholders, so the values stay empty. Reading the
 * state instead of relying on the events covers Cookiebot getting ready before
 * the app starts listening. The CookieConsent cookie is not JSON, don't parse it.
 */
export const readConsent = () => {
  const { hasResponse, consent } = window.Cookiebot ?? {};

  if (!hasResponse || !consent) {
    return { consent_marketing: '', consent_statistics: '' };
  }

  return {
    consent_marketing: String(Boolean(consent.marketing)),
    consent_statistics: String(Boolean(consent.statistics)),
  };
};

export const onConsentChange = (handler: () => void): (() => void) => {
  CONSENT_EVENTS.forEach((event) => window.addEventListener(event, handler));

  return () =>
    CONSENT_EVENTS.forEach((event) =>
      window.removeEventListener(event, handler),
    );
};
